import { Center, Spinner } from "@chakra-ui/react"

export const InnerLoading = () => {

    return (
        <Center mt={5}>
            <Spinner />
        </Center>
    )
}